import { useEffect, useRef } from "react";

export const useOnChange = (func, inputs) => {
    const didMoutRef = useRef(false);

    const changeCounts = [];
    const values = [];

    for (const input of inputs) {
        changeCounts.push(input.ref ? input.changeCount : null);
        values.push(input.ref ? input.value : null);
    }

    const valuesRef = useRef(values);
    const changeCountsRef = useRef(changeCounts);

    useEffect(() => {
        if (!didMoutRef.current) {
            didMoutRef.current = true;
            return;
        }
        changeCounts.forEach((changeCount, index) => {
            const c1 = changeCountsRef.current[index];
            const c2 = changeCount;

            if (c1 === c2) {
                return;
            }

            const value = values[index];
            const v1 = JSON.stringify(valuesRef.current[index]);
            const v2 = JSON.stringify(value);

            if (v1 !== v2) {
                const input = inputs[index];
                if (input !== null) {
                    const { name, ignore } = input;
                    func(name, value, ignore);
                }
            }
        });
        valuesRef.current = values;
        changeCountsRef.current = changeCounts;
    }, [...changeCounts, ...values]);
};

